<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <div
        class="el-divider"
        :class="{
            [`el-divider--color-${color}`]: color,
            'is-vertical': vertical
        }"
        :style="`height: ${height}px`"
    />
</template>

<script setup>
import { isInteger } from 'lodash-es';
import { ref } from 'vue';

const props = defineProps({
    color: { type: String, default: 'brand-accent' },
    vertical: { type: [Boolean, Number], default: false },
});

const height = ref(isInteger(props.vertical) ? props.vertical : null);
</script>

<style scoped>
.el-divider {
    margin: 8px auto;
    width: 100%;
    height: 1px;
    min-height: 1px;
    vertical-align: middle
}

.el-divider--color-brand-light {
    background-color: var(--av-brand-light)
}

.el-divider--color-brand-lightest {
    background-color: var(--av-brand-lightest)
}

.el-divider--color-brand-accent {
    background-color: var(--av-brand-accent)
}

.el-divider.is-vertical {
    display: block;
    width: 1px;
    min-width: 1px;
    min-height: 24px;
    height: 100%;
}
</style>
